// Messages for portal/shipments/Timeline (auto-merged by lib/i18n.ts).
export const en = {
  'portal.timeline.atd': 'ATD ',
  'portal.timeline.eta': 'ETA ',
  'portal.timeline.eta_compact': 'ETA {eta}',
}

export const zhTW = {
  'portal.timeline.atd': '實際出發 ',
  'portal.timeline.eta': '預計到達 ',
  'portal.timeline.eta_compact': '預計到達 {eta}',
}
